import React from 'react';
import { motion } from 'framer-motion';
import { FiAlertCircle, FiRefreshCw } from 'react-icons/fi';
import './ErrorMessage.css';

/**
 * Error message display component
 */
const ErrorMessage = ({ message, onRetry }) => {
  return (
    <motion.div
      className="error-container"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
    >
      <div className="error-content">
        <div className="error-icon">
          <FiAlertCircle />
        </div>

        <div className="error-text">
          <h3 className="error-title">Oops! Something went wrong</h3>
          <p className="error-message">{message}</p>
        </div>

        <motion.button
          className="retry-button"
          onClick={onRetry}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FiRefreshCw />
          <span>Try Again</span>
        </motion.button>
      </div>

      <div className="error-decoration">
        <div className="decoration-line"></div>
        <div className="decoration-dot"></div>
      </div>
    </motion.div>
  );
};

export default ErrorMessage;
